import "./Work.scss";
import React, { useState } from "react";
import { Stack, Container, Image } from "react-bootstrap";
import { Link } from "react-router-dom";

import agro from "../assets/work/agro.png";
import DentalProtection from "../assets/work/dental-protection.png";
import aurelia from "../assets/work/aurelia.png";
import Glamora from "../assets/work/glamora.png";
import PushpanjaliDresses from "../assets/work/pushpanjali-dresses.png";
import bhumirajSweet from "../assets/work/bhumiraj-website-1.jpeg";
import bhumirajSweetAd1 from "../assets/work/bhumiraj-product-ad.png";
import bhumirajSweetAd2 from "../assets/work/bhumiraj-ganapati-ad.png";
import bhumirajSweetLogo from "../assets/work/bhumiraj-logo.png";
import BendreJewellersWeb from '../assets/work/bendre-jewellers-web.png';
import BendreJewellersLogo from '../assets/work/bendre-jewellers-logo.png';
import AyushreemLogo from '../assets/work/ayushreem-logo.png';
import AyushreemPrint from '../assets/work/ayushreem-print.png';
import AyushreemWeb from '../assets/work/ayushreem-website.png';
import AbcSchool from '../assets/work/abc-school.png';
import VcrumbPost from '../assets/work/VcrumbPost.png';

import work1 from "../assets/work/gallery-1.jpg";
import work2 from "../assets/work/gallery-2.jpg";
import work3 from "../assets/work/gallery-3.jpg";
import work4 from "../assets/work/gallery-4.jpg";
import work5 from "../assets/work/gallery-5.jpg";
import work6 from "../assets/work/gallery-6.jpg";
import work8 from "../assets/work/wrok-2.png";
import work9 from "../assets/work/wrok-3.png";
import work10 from "../assets/work/wrok-5.png";
import work11 from "../assets/work/wrok-6.png";
import work12 from "../assets/work/wrok-7.png";
import web3 from "../assets/work/web-3.png";
import work13 from "../assets/work/wrok-8.jpg";
import work14 from "../assets/work/wrok-9.jpg";
import work15 from "../assets/work/wrok-10.jpg";
import work16 from "../assets/work/wrok-14.jpg";

function Work({ setactivelink }) {
  const [isVisible, setIsVisible] = useState(true);
  const [activeTab, setActiveTab] = useState("website");

  return (
    <Stack id="work" gap={6} className="work">
      <Container className="py-4">
        <h1 className="section-title">Work</h1>

        {/* Work Tabs */}
        <div className="work-tabs">
          <button
            className={activeTab === "website" ? "active" : ""}
            onClick={() => setActiveTab("website")}
          >
            Website
          </button>

          <button
            className={activeTab === "social-media" ? "active" : ""}
            onClick={() => setActiveTab("social-media")}
          >
            Digital Marketing
          </button>

          <button
            className={activeTab === "graphic" ? "active" : ""}
            onClick={() => setActiveTab("graphic")}
          >
            Corporate Branding
          </button>
        </div>

        <div className="work-images">

          {/* WEBSITE */}
          {activeTab === "website" && (
            <>
              <div className="img-wrapper">
                <Link to="/work/case-study/agro-industries">
                  <Image src={agro} alt="Agro Industries" width="100%" />
                </Link>
              </div>

              <div className="img-wrapper">
                <Link to="/work/case-study/dental-protection">
                  <Image
                    src={DentalProtection}
                    alt="Dental Protection"
                    width="100%"
                  />
                </Link>
              </div>

              <div className="img-wrapper">
                <Link to="/work/case-study/aurelia-heights">
                  <Image src={aurelia} alt="Aurelia Heights" width="100%" />
                </Link>
              </div>

              <div className="img-wrapper">
                <Link to="/work/case-study/glamora">
                  <Image src={Glamora} alt="Glamora" width="100%" />
                </Link>
              </div>

              <div className="img-wrapper">
                <Link to="/work/case-study/pushpanjali-dresses">
                  <Image
                    src={PushpanjaliDresses}
                    alt="Pushpanjali Dresses"
                    width="100%"
                  />
                </Link>
              </div>

              <div className="img-wrapper">
                <Link to="/work/case-study/bhumiraj-sweet">
                <Image src={bhumirajSweet} alt="Bhumiraj Sweet" width="100%" /></Link>
              </div>
               <div className="img-wrapper">
                <Link to="/work/case-study/bendre-jewellers">
                <Image src={BendreJewellersWeb} alt="Bendre Jewellers" width="100%" /></Link>
              </div>
               <div className="img-wrapper">
                <Link to="/work/case-study/ayushreem">
                <Image src={AyushreemWeb} alt="Ayushreem Hospital" width="100%" /></Link>
              </div>
            </>
          )}

          {/* SOCIAL MEDIA */}
          {activeTab === "social-media" && (
            <>
              <div className="img-wrapper">
                <Image src={bhumirajSweetAd1} alt="Bhumiraj Sweet" width="100%" />
              </div>
              <div className="img-wrapper">
                <Image src={bhumirajSweetAd2} alt="Bhumiraj Sweet" width="100%" />
              </div>
              <div className="img-wrapper">
                <Image src={AbcSchool} alt="ABC Montessori" width="100%" />
              </div>
              <div className="img-wrapper">
                <Image src={VcrumbPost} alt="Vcrumb" width="100%" />
              </div>              
               <div className="img-wrapper">
                <Image src={work8} alt="Graphic Design" width="100%" />
              </div>
              <div className="img-wrapper">
                <Image src={work9} alt="Graphic Design" width="100%" />
              </div>
              <div className="img-wrapper">
                <Image src={work10} alt="Graphic Design" width="100%" />
              </div>
              <div className="img-wrapper">
                <Image src={work11} alt="Graphic Design" width="100%" />
              </div>
              <div className="img-wrapper">
                <Image src={work12} alt="Graphic Design" width="100%" />
              </div>
              <div className="img-wrapper">
                <Image src={work13} alt="Graphic Design" width="100%" />
              </div>
              <div className="img-wrapper">
                <Image src={work14} alt="Graphic Design" width="100%" />
              </div>
              <div className="img-wrapper">
                <Image src={work15} alt="Graphic Design" width="100%" />
              </div>
            </>
          )}

          {/* GRAPHIC */}
          {activeTab === "graphic" && (
            <>
              <div className="img-wrapper">
                <Image src={AyushreemLogo} alt="Ayushreem Hospital" width="100%" />
              </div>
              <div className="img-wrapper">
                <Image src={AyushreemPrint} alt="Bhumiraj Sweet" width="100%" />
              </div>
              <div className="img-wrapper">
                <Image src={work16} alt="Graphic Design" width="100%" />
              </div>
              <div className="img-wrapper">
                <Image src={BendreJewellersLogo} alt="Bendre Jewellers" width="100%" />
              </div>
              <div className="img-wrapper">
                <Image src={bhumirajSweetLogo} alt="Bhumiraj Sweet" width="100%" />
              </div>
              <div className="img-wrapper">
                <Image src={work1} alt="Social Media Design" width="100%" />
              </div>

              <div className="img-wrapper">
                <Image src={work2} alt="Social Media Design" width="100%" />
              </div>

              <div className="img-wrapper">
                <Image src={work3} alt="Social Media Design" width="100%" />
              </div>

              <div className="img-wrapper">
                <Image src={work4} alt="Social Media Design" width="100%" />
              </div>

              <div className="img-wrapper">
                <Image src={work5} alt="Social Media Design" width="100%" />
              </div>

              <div className="img-wrapper">
                <Image src={work6} alt="Social Media Design" width="100%" />
              </div>
            </>
          )}

          {/* Show All / Show Less */}
          {/* <div className="text-center w-100 p-3">
            <button
              className="btn btn-danger px-5"
              onClick={() => setIsVisible(!isVisible)}
            >
              {isVisible ? "Show All" : "Show Less"}
            </button>
          </div> */}
        </div>
      </Container>
    </Stack>
  );
}

export default Work;